export class EdiMatlConv{

    isSaved :string;
    rowCheck: boolean;
    
    sapPayerNum : string;

    ediTpMatlNum : string;

    sapMatlNum : string;

    sapMixDescr : string;

   ediTpConvFactor : number;

    ediTpUom : string;

   sapQtyConvFactor : number;

    sapQtyUom : string;

   ediTpPriceConvFactor : number;

    ediTpPriceUom : string;

   sapPriceConvFactor : number;

    sapPriceUom : string;

   createionDate : string;

   ediTpMatlNumOriginal: string;
   constructor(
    sapMatlNum:string,
    ediTpMatlNum:string,
    sapMixDescr:string,
    sapPayerNum:string,
    ediTpConvFactor:number,
    ediTpUom:string,
    sapQtyConvFactor:number,
    sapQtyUom:string,
    ediTpPriceConvFactor:number,
    ediTpPriceUom:string,
    sapPriceConvFactor:number,
    sapPriceUom:string,
    ediTpMatlNumOriginal:string
   ){
     this.sapMatlNum=sapMatlNum;
    this.ediTpMatlNum = ediTpMatlNum;
    this.sapMixDescr =  sapMixDescr;
    this.sapPayerNum =  sapPayerNum;
    this.ediTpConvFactor =  ediTpConvFactor;
    this.ediTpUom =  ediTpUom;
     this.sapQtyConvFactor =  sapQtyConvFactor;
     this.sapQtyUom =  sapQtyUom;
    this.ediTpPriceConvFactor =  ediTpPriceConvFactor;
    this.ediTpPriceUom =  ediTpPriceUom;
    this.sapPriceConvFactor =  sapPriceConvFactor;
     this.sapPriceUom =  sapPriceUom;
     this.ediTpMatlNumOriginal=ediTpMatlNumOriginal;
   }
}